import { render, staticRenderFns } from "./rejectReason.vue?vue&type=template&id=4cb74444&scoped=true"
import script from "./rejectReason.vue?vue&type=script&lang=js"
export * from "./rejectReason.vue?vue&type=script&lang=js"
import style0 from "./rejectReason.vue?vue&type=style&index=0&id=4cb74444&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb74444",
  null
  
)

export default component.exports